import { render, staticRenderFns } from "./AutoaddressSearch.vue?vue&type=template&id=e96a6340"
import script from "./AutoaddressSearch.vue?vue&type=script&lang=ts"
export * from "./AutoaddressSearch.vue?vue&type=script&lang=ts"
import style0 from "./AutoaddressSearch.vue?vue&type=style&index=0&id=e96a6340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports